import type { FaireProductEntity } from "../../entity_types/product";

export const p_kedshd58kf: FaireProductEntity = {
  token: "p_kedshd58kf",
  type: "product",
  name: "Queen bee pearl necklace boutique salon bee Jewerly  trendy",
  brandToken: "b_dqpjwo1i",
  brandName: "VB&CO Designs Handmade Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/2bb94cc2e9d3f9f681e0bfd0c6de6e3a27c729e837010c2e457700ca5d2a2bb1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5a819c721e17ec970879fc47cf05735521857fe9906a409a9f7a7fc1d9f90234.jpeg",
    "https://cdn.faire.com/fastly/7b34417170e7657adcf75d2e0bcee2701aa9afba1a07689d2faae32e5b2963d3.jpeg",
    "https://cdn.faire.com/fastly/85580eb39780e68c68949cd151758edf678bc548a03095f3e77834644688963a.jpeg",
    "https://cdn.faire.com/fastly/2d0d724fb1a87a818e8dd6beed8841ffdcd2772fe0f006fa407e8830a0839dbd.jpeg",
  ],
  priceDollars: 33,
  description:
    "Genuine baroque fresh water pearls with tiny clear crystals. Features a hand casted toggle and reversible bee/crown pendant. Choose your length\n\nStudio Notes: S/A in white/silver pearl",
  tags: [],
  msrpDollars: 83,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:50.512Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
